import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-driver-edit-modal',
  templateUrl: './driver-edit-modal.component.html',
  styleUrls: ['./driver-edit-modal.component.css']
})
export class DriverEditModalComponent implements OnInit {

@Input() driver: any;
@Output() onCloseModal = new EventEmitter<string>();
@Output() onSave = new EventEmitter<any>();

ngOnInit(): void {

}

 onSaveDriver(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }

}
